








































































































































import Vue, { PropType } from "vue";

import Locale from "@/lib/locale";
import Ice from "@/lib/ice";
import queryString from "qs";

export interface OffersWacomPlansProps {
  lang: any;
  deviceChoice: any;
  gradeChoice: any;
  termChoice: any;
  countryChoice: any;
  currencyChoice: any;
  resultPlansMap: any;
  defaultData: any;
  action: string;
  device_type: string;
  extendParams: any;
  priceMap: any;
  vandleCardUrl: string;
}

export default Vue.extend({
  name: "vc-offers-wacom-plans",
  data() {
    return {
      device_type: this.defaultData.device_type,
      grade_type: this.defaultData.grade_type,
      term_type: this.defaultData.term_type,
      currency_code: this.defaultData.currency_code,
      country_code: this.defaultData.country_code,
      monthlyPrice: this.priceMap[
        this.resultPlansMap[this.defaultData.device_type][
          this.defaultData.grade_type
        ]["month"]
      ][this.defaultData.currency_code],
      yearlyPrice: this.priceMap[
        this.resultPlansMap[this.defaultData.device_type][
          this.defaultData.grade_type
        ]["year"]
      ][this.defaultData.currency_code],
      locale: Locale.getLocale(),
      isIce: Ice.isIce()
    };
  },
  props: {
    lang: {
      type: Object as PropType<OffersWacomPlansProps["lang"]>,
      default: () => {}
    },
    deviceChoice: {
      type: Object as PropType<OffersWacomPlansProps["deviceChoice"]>,
      default: () => {}
    },
    gradeChoice: {
      type: Object as PropType<OffersWacomPlansProps["gradeChoice"]>,
      default: () => {}
    },
    termChoice: {
      type: Object as PropType<OffersWacomPlansProps["termChoice"]>,
      default: () => {}
    },
    countryChoice: {
      type: Array as PropType<OffersWacomPlansProps["countryChoice"]>,
      default: () => []
    },
    currencyChoice: {
      type: Array as PropType<OffersWacomPlansProps["currencyChoice"]>,
      default: () => {}
    },
    resultPlansMap: {
      type: Object as PropType<OffersWacomPlansProps["resultPlansMap"]>,
      default: () => {}
    },
    defaultData: {
      type: Object as PropType<OffersWacomPlansProps["defaultData"]>,
      default: () => {}
    },
    extendParams: {
      type: Object as PropType<OffersWacomPlansProps["extendParams"]>,
      default: () => {}
    },
    action: {
      type: String as PropType<OffersWacomPlansProps["action"]>,
      default: ""
    },
    priceMap: {
      type: Object as PropType<OffersWacomPlansProps["priceMap"]>,
      default: () => {}
    },
    vandleCardUrl: {
      type: String as PropType<OffersWacomPlansProps["vandleCardUrl"]>,
      default: ""
    }
  },
  computed: {
    firstCountryList(): Object[] {
      return this.countryChoice.filter(function(country: any) {
        if (country.display_list_priority == 1) return true;
      });
    },
    secondCountryList(): Object[] {
      return this.countryChoice.filter(function(country: any) {
        if (country.display_list_priority == 2) return true;
      });
    }
  },
  methods: {
    submitPlan() {
      const formElement = this.$refs.formOffers as HTMLFormElement;
      const inputPlan = document.createElement("input");
      inputPlan.setAttribute("type", "hidden");
      inputPlan.setAttribute("name", "plan_code");
      inputPlan.setAttribute(
        "value",
        this.resultPlansMap[this.device_type][this.grade_type][this.term_type]
      );
      formElement.appendChild(inputPlan);

      let params: any = {};

      for (let element of formElement.elements) {
        if (element instanceof HTMLInputElement) {
          if (element.type === "radio") {
            if (element.checked) {
              params[element.name] = element.value;
            }
          } else {
            params[element.name] = element.value;
          }
        } else if (element instanceof HTMLSelectElement) {
          params[element.name] = element.value;
        }
      }

      const url = formElement.action + `?${queryString.stringify(params)}`;

      if (Ice.isIce()) {
        Ice.openUrl(url, true);
      } else {
        window.location.href = url;
      }
    },

    changePrice() {
      this.monthlyPrice = this.priceMap[
        this.resultPlansMap[this.device_type][this.grade_type]["month"]
      ][this.currency_code];
      this.yearlyPrice = this.priceMap[
        this.resultPlansMap[this.device_type][this.grade_type]["year"]
      ][this.currency_code];
    }
  },
  watch: {}
});
